import { NavLink } from 'react-router-dom';
import { item } from '../../utils/animations';
import styles from './FooterSubSections.module.css';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

export const FooterEvent = () => {
    const { t } = useTranslation();
    return (
        <motion.div
            className={styles.wrapper}
            variants={item}
        >
            <h1 className={styles.title}>
                {t('shared.events.events')}
            </h1>
            <div className={styles.body}>
                {/** <section id="restaurant"> */}
                <NavLink
                    to="/#restaurant"
                    className={styles.text}
                >
                    {t('shared.events.restaurant')}
                </NavLink>
                {/** <section id="bar"> */}
                <NavLink
                    to="/#bar"
                    className={styles.text}
                >
                    {t('shared.events.bar')}
                </NavLink>
                {/** <section id="meetup"> */}
                <NavLink
                    to="/#meetup"
                    className={styles.text}
                >
                    {t('shared.events.meetup')}
                </NavLink>
            </div>
        </motion.div>
    )
}